// nosemgrep: nodejs_scan.javascript-crypto-rule-node_insecure_random_generator
export class MathUtils {
  /**
   * Random integer between min and max (both included)
   */
  static rand(min: number, max: number): number {
    if (min >= max) {
      throw new Error('Incorrect range')
    }

    const randomBuffer = new Uint32Array(1)
    crypto.getRandomValues(randomBuffer)
    const randomUint32 = randomBuffer[0]

    // 4294967296 is the maximum possible Uint32 value
    const randomDecimal = randomUint32 / 4294967296

    const rangeSize = max - min
    const valueInRange = randomDecimal * rangeSize + min

    return Math.round(valueInRange)
  }

  static roundToPrecision(value: number, precision: number): number {
    return Number(
      new Intl.NumberFormat('en-US', {
        useGrouping: false,
        minimumFractionDigits: precision,
        maximumFractionDigits: precision,
      }).format(value),
    )
  }
}
